import React from 'react';

import { token } from '@atlaskit/tokens';
import Icon from '@atlaskit/icon';
import type { GlyphProps } from '@atlaskit/icon/types';

const fireSvg = () => (
	<svg width="17" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_7_29729)">
			<path
				d="M23.3334 12.6667C23.3334 11.292 23.0887 9.97402 22.64 8.75468C22.3334 12.3473 20.418 14.1927 18.4167 13.3333C16.542 12.528 17.8054 9.38868 17.8987 7.89068C18.056 5.35135 17.8907 2.44468 13.278 0.0280151C15.1947 3.69468 13.5 5.97268 11.7227 6.11135C9.75069 6.26535 7.94469 4.41668 8.61135 1.41668C6.45269 3.00735 6.39002 5.68468 7.05602 7.41668C7.75069 9.22202 7.02802 10.722 5.33402 10.8887C3.44069 11.0753 2.38869 8.86135 3.35869 5.33335C1.68002 7.31002 0.666687 9.87002 0.666687 12.6667C0.666687 18.926 5.74069 24 12 24C18.2594 24 23.3334 18.926 23.3334 12.6667Z"
				fill={token('color.background.accent.orange.subtle', '#F4900C')}
			/>
			<path
				d="M18.9293 15.9994C19.028 18.0554 17.222 18.8614 16.25 18.472C14.846 17.91 15.2227 16.9447 14.8613 14.9447C14.5 12.9447 13.1113 11.556 11.056 10.9447C12.556 15.1667 10.2247 16.7227 9.00267 17.0007C7.75467 17.2847 6.50067 17 6.35733 14.3294C4.90133 15.7787 4 17.784 4 20C4 20.2454 4.01533 20.4867 4.03667 20.7267C6.08333 22.7494 8.89467 24 12 24C15.1053 24 17.9167 22.7494 19.9633 20.7267C19.9847 20.4867 20 20.2454 20 20C20 18.542 19.6107 17.176 18.9293 15.9994Z"
				fill={token('color.background.accent.orange.subtle', '#FFCC4D')}
			/>
		</g>
		<defs>
			<clipPath id="clip0_7_29729">
				<rect width="24" height="24" fill="none" />
			</clipPath>
		</defs>
	</svg>
);

export const FireIcon = (props: GlyphProps) => <Icon glyph={fireSvg} {...props} />;
